var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.629 10.063L9.28404 5.54899C9.24461 5.50961 9.21333 5.46285 9.19199 5.41137C9.17065 5.35989 9.15967 5.30472 9.15967 5.24899C9.15967 5.19327 9.17065 5.13809 9.19199 5.08661C9.21333 5.03514 9.24461 4.98837 9.28404 4.94899C9.32256 4.90987 9.36849 4.8788 9.41913 4.85759C9.46978 4.83638 9.52413 4.82546 9.57904 4.82546C9.63395 4.82546 9.68831 4.83638 9.73895 4.85759C9.7896 4.8788 9.83552 4.90987 9.87404 4.94899L14.637 9.76399C14.6765 9.80337 14.7077 9.85014 14.7291 9.90161C14.7504 9.95309 14.7614 10.0083 14.7614 10.064C14.7614 10.1197 14.7504 10.1749 14.7291 10.2264C14.7077 10.2778 14.6765 10.3246 14.637 10.364L9.87404 15.171C9.83552 15.2101 9.7896 15.2412 9.73895 15.2624C9.68831 15.2836 9.63395 15.2945 9.57904 15.2945C9.52413 15.2945 9.46978 15.2836 9.41913 15.2624C9.36849 15.2412 9.32256 15.2101 9.28404 15.171C9.24461 15.1316 9.21333 15.0848 9.19199 15.0334C9.17065 14.9819 9.15967 14.9267 9.15967 14.871C9.15967 14.8153 9.17065 14.7601 9.19199 14.7086C9.21333 14.6571 9.24461 14.6104 9.28404 14.571L13.629 10.063Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8362 10.067H5.51123",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.41406 10.1962C1.41406 15.2662 5.53884 19.391 10.6089 19.391C15.6789 19.391 19.8037 15.2662 19.8037 10.1962C19.8037 5.12613 15.6789 1.00135 10.6089 1.00135C5.53884 1.00135 1.41406 5.12613 1.41406 10.1962ZM0.414063 10.1962C0.414063 4.56572 4.97843 0.0013504 10.6089 0.0013504C16.2393 0.0013504 20.8037 4.56572 20.8037 10.1962C20.8037 15.8266 16.2393 20.391 10.6089 20.391C4.97843 20.391 0.414063 15.8266 0.414063 10.1962Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircle);
export default __webpack_public_path__ + "static/media/arrow-circle.a5d89636a0fb4afb72d0c005c1c5e95b.svg";
export { ForwardRef as ReactComponent };